import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Global } from './Global';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ModuleService {
  private _http = inject(HttpClient);
  private _url = Global.url_evaluation;
  private _headers = new HttpHeaders().set('Content-Type', 'application/json');

  getModules(): Observable<any> {
    return this._http.get(this._url + 'modules', { headers: this._headers });
  }

  getActiveModules(): Observable<any> {
    return this._http.get(this._url + 'modules/active', { headers: this._headers });
  }

  getUserModules(): Observable<any> {
    return this._http.get(this._url + 'modules/user-modules', { headers: this._headers });
  }

  upsertModule(module: any): Observable<any> {
    return this._http.put(this._url + 'modules', module, { headers: this._headers });
  }

  toggleModule(id: string, enabled: boolean): Observable<any> {
    return this._http.patch(this._url + 'modules/toggle', { id, enabled }, { headers: this._headers });
  }

  getModuleById(id: string): Observable<any> {
    return this._http.get(this._url + 'modules/' + id, { headers: this._headers });
  }
}
